import React, { Component } from 'react';
import { connect } from 'react-redux';
import {isUserLoggedIn,getMembershipEmail} from '../actions';

class CommitteeColleagues extends Component {

	constructor(){
		super();
		this.state = {viewColleagues :[]};
	}

	getColleaguesHTML(ccode){
		//checking to see if committee codes is shown within the state.
		if(this.state.viewColleagues.includes(ccode)){
			//check if any colleagues exist within committee.
			if(this.props.committeeColleagues[ccode].length <= 0 ){
				return (<div>No Colleagues in this Committee.</div>)
			}
			return(
				<div className="view-colleagues"> <button className="view-details text-button view-colleagues-gtm" data-ccode={ccode} onClick={this.displayCommitteeColleagues.bind(this,ccode)} type="button">Hide My Colleagues
					<i data-ccode={ccode} className="fa fa-chevron-up view-colleagues-gtm" aria-hidden="true" /></button>
						<div>
							{this.getCommitteeColleagues(ccode)}
						</div>
					</div>
		);

		} else {
			//displaying view my colleagues.
			return (<button className="view-details text-button view-colleagues-gtm" data-ccode={ccode} onClick={this.displayCommitteeColleagues.bind(this,ccode)} type="button">View My Colleagues
				<i data-ccode={ccode} className="fa fa-chevron-down view-colleagues-gtm" aria-hidden="true" /></button>)
		}
	}

	getCommitteeColleagues(ccode){
		let committeeColleagues = this.props.committeeColleagues[ccode].map(colleague => {
			let committee_chair = '';
			if(colleague.COMMITTEE_MEMBERSHIP_TYPE === 'MEMBLD'){
				committee_chair = ' (Committee Lead)';
			}
			return (<div className="committee-colleague">{colleague.FIRST_NAME + ' ' + colleague.LAST_NAME + committee_chair}</div>);
		});
		let defaultEmail = getMembershipEmail();
		let email = (this.props.email !== '') ? this.props.email : defaultEmail;
		committeeColleagues.push(<br/>);
		committeeColleagues.push(<div className={"committee-colleague"}>
			<a className={'committee-colleague-email'} data-ccode={ccode} data-value="Hide My Name" href={'mailto:'+defaultEmail+'?subject=Hide My Name'}>Hide My Name <i data-value="Hide My Name" data-ccode={ccode} class="glyphicon glyphicon-envelope colleagues-mail-icon committee-colleague-email"></i></a>
		</div>);
		committeeColleagues.push(<div className={"committee-colleague"}>
			<a className={'committee-colleague-email'} data-ccode={ccode} data-value="Remove Colleague No Longer at Firm" href={'mailto:'+email+'?subject=Remove Colleague No Longer at Firm'}>Remove Colleague No Longer at Firm <i data-value="Remove Colleague No Longer at Firm" data-ccode={ccode} class="glyphicon glyphicon-envelope colleagues-mail-icon committee-colleague-email"></i></a>
		</div>);
		committeeColleagues.push(<div className={"committee-colleague"}>
			<a className={'committee-colleague-email'} data-ccode={ccode} data-value="Remove or Add Key Committee Lead" href={'mailto:'+email+'?subject=Remove or Add Key Committee Lead'}>Remove or Add Key Committee Lead <i data-value="Remove or Add Key Committee Lead" data-ccode={ccode} class="glyphicon glyphicon-envelope colleagues-mail-icon committee-colleague-email"></i></a>
		</div>);
		return committeeColleagues;
	}

	displayCommitteeColleagues(ccode){
		const newState = this.state.viewColleagues;
		//displaying colleagues
		if(!newState.includes(ccode)){
			newState.push(ccode);
		} else{ //hide display.
			let index = newState.indexOf(ccode);
			if(index > -1){
				newState.splice(index,1);
			}
		}
		this.setState({viewColleagues:newState});
	}

	render() {
		const ccode = this.props.ccode;
		let viewMeetings = '';
		let colleaguesHTML = '';
		//checking if user is logged in and if the current committee is part of myCommittees.
		if ( isUserLoggedIn() && this.props.myCommittees.includes( ccode ) ) {
				//checking if committee code exist in committee colleagues.
				if ( typeof this.props.committeeColleagues[ ccode ] !== 'undefined' ) {
					colleaguesHTML = this.getColleaguesHTML(ccode);
			}
		}
		return(
			<div>
				{viewMeetings}
				{colleaguesHTML}
			</div>
		)

	}


}

function mapStateToProps( { committees, myCommittees, committeeColleagues } ) {
	return {
		committees, myCommittees, committeeColleagues
	};
}

export default connect( mapStateToProps )( CommitteeColleagues );